export default {
  Form_Tips_Common: {
    enter_clinc_name: '请输入诊所名称',
    enter_clinc_code: '请输入诊所编码',
    enter_details_address: '请输入详细地址',
    enter_phone: '请输入电话',
    select_administrator: '请选择管理员',
    letter_letters_numbers: '以字母开头，大小写字母、数字及“-”之组合',
    QingShuRu_JingZhong: '请输入净重(如:200g)',
    XiuGai_MiMa_GuiZe: '*必须包含数字，大写字母，小写字母，特殊字符的任意三种组合并且长度为6~16',
    enter_project_name: '请输入项目名称',
    enter_project_price: '请输入项目价格',
    enter_project_duration: '请输入项目时长',
    enter_role_name: '请输入角色名',
    select_clinic_codes: '请选择诊所',
    select_data_scope: '请选择权限范围',
    enter_product_name: '请输入商品名称',
    enter_product_price: '请输入商品价格',
    enter_new_password: '请输入新密码',
    enter_old_password: '请输入原密码',
    enter_new_account: '请输入新账号',
    enter_new_nickname: '请输入新暱称',
    enter_new_en_name: '请输入新英文名',
    password_format_error: '密码格式错误',
    password_length_tip: '密码长度为6~16位',
    enter_keyword: '请输入名称或编码',
    enter_name: '请输入名称',
    enter_code: '请输入编码',
    enter_org_code: '请输入组织编码',
    enter_org_name: '请输入组织名称',
    enter_batch_number: '请输入批号',
    enter_domain: '请输入域名',
    un_available_option: '无可用选项',
    enter_password: '请输入密码',
    select_zhu_huanzhe: '请选择主患者',
    select_dai_hebing: '请选择待合并患者',
    select_org: '请选择组织',
    enter_secret_name: '请输入秘钥名称',
  },
}
